import React from 'react';
import { useAppSelector } from '#app/hooks/useAppStore';
import { List } from './styles';

const PerPage = ({ data, onPerPageChange, variants = [10, 25, 50] }) => {
  const i18n = useAppSelector((s) => s.i18n);

  const handlePageChange = (value) => {
    onPerPageChange(value);
  };

  return (
    <List>
      {i18n.common.showBy}
      {variants.map((value, key) => {
        if (value === 'Все') {
          return (
            <li
              key={key}
              id={'per-page-' + value}
              className={
                parseInt(data.per_page) === 10000 || data.per_page === 'Все' ? 'active' : ''
              }
            >
              <a onClick={() => handlePageChange(value)}>{value}</a>
            </li>
          );
        }

        return (
          <li
            key={key}
            id={'per-page-' + value}
            className={parseInt(data.per_page) === parseInt(value) ? 'active' : ''}
          >
            <a onClick={() => handlePageChange(value)}>{value}</a>
          </li>
        );
      })}
    </List>
  );
};

export default PerPage;
